/*
  A taxonomy-filter Vue 3 app!

  Vue 3: https://vuejs.org/guide/introduction.html 
  (select 'Composition' as your API preference)

  Build tasks:
    gulp storeList
    npm run storeList

  Watch task:
    gulp watchStoreList

  Config file:
    vite.config.storeList.js
*/
import { createApp } from 'vue';
import App from './storeList/App.vue';

createApp(App).mount("#tzo-store-list-app");
